import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {EnginesResponse} from '../models/engine/engines.response';
import {Engine} from '../models/engine/engine.model';
import {JobEngineResponse} from '../models/engine/jobEngine.response';
import {JobEngine} from '../models/engine/jobEngine.model';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EngineService {

  constructor(private http: HttpClient) {
  }

  private ENGINE_URL: string = environment.BASE_URL + 'engine';
  private JOB_ENGINE_URL: string = environment.BASE_URL + 'job';

  /**
   * GETS
   */
  public getEngines(): Observable<EnginesResponse> {
    return this.http.get<EnginesResponse>(`${this.ENGINE_URL}`).pipe(map(engines => ({
      engines: engines.engines.sort((e1, e2) => {
        return `${e1?.make}${e1.model}`.localeCompare(`${e2?.make}${e2.model}`);
      }),
      attributes: engines.attributes,
      categories: engines.categories
    })));
  }

  public getJobEngine(id: string): Observable<JobEngineResponse> {
    return this.http.get<JobEngineResponse>(`${this.JOB_ENGINE_URL}/${id}/engine`).pipe();
  }

  public getEngine(id: string): Observable<Engine> {
    return this.http.get<Engine>(`${this.ENGINE_URL}/${id}`).pipe(
    );
  }

  /**
   * CREATES
   */
  public createEngine(engine: Engine): Observable<Engine> {
    return this.http.post<Engine>(`${this.ENGINE_URL}`, engine).pipe();
  }


  /**
   * UPDATES
   */
  public updateEngine(engine: Engine): Observable<Engine> {
    return this.http.patch<Engine>(`${this.ENGINE_URL}/${engine.id}`, engine).pipe();
  }

  public updateJobEngine(jobEngine: JobEngine): Observable<JobEngineResponse> {
    return this.http.patch<JobEngineResponse>(`${this.JOB_ENGINE_URL}/${jobEngine.id}/engine`, jobEngine).pipe();
  }

  /**
   * DELETE
   */
  public deleteEngine(id: string): Observable<Engine> {
    return this.http.delete<Engine>(`${this.ENGINE_URL}/${id}`).pipe();
  }

}
